(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kvcw-nieuws-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.currentScript && document.currentScript.closest('.shopify-section');
    el = (el && el.querySelector('.kvnws')) || document.querySelector('.kvnws');
    if (!el) return;
    if (el.dataset.kvnwsInit) return;
    el.dataset.kvnwsInit = '1';

    // In de Theme Editor altijd tonen, geen gate.
    if (window.Shopify && window.Shopify.designMode) return;

    var force = /[?&]kvcwnews=preview/.test(window.location.search);

    // "JJJJ-MM-DD UU:MM" in Belgische tijd -> epoch ms (met zomer/wintertijd).
    function lastSunday(y, m) {
      var d = new Date(Date.UTC(y, m + 1, 0));
      return d.getUTCDate() - d.getUTCDay();
    }
    function parseBx(s) {
      var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(s || '');
      if (!m) return 0;
      var y = +m[1], mo = +m[2] - 1, d = +m[3], h = +m[4], mi = +m[5];
      var t = Date.UTC(y, mo, d, h, mi);
      var dstStart = Date.UTC(y, 2, lastSunday(y, 2), 1);
      var dstEnd = Date.UTC(y, 9, lastSunday(y, 9), 1);
      var off = (t >= dstStart && t < dstEnd) ? 2 : 1;
      return t - off * 3600000;
    }

    var rel = parseBx(el.dataset.release);
    var end = parseBx(el.dataset.end);

    function check() {
      var now = Date.now();
      if (force) { el.removeAttribute('hidden'); return; }
      if (rel && now < rel) {
        el.setAttribute('hidden', '');
        var wait = Math.min(rel - now + 500, 6 * 3600000);
        setTimeout(check, wait);
        return;
      }
      if (end && now >= end) { el.setAttribute('hidden', ''); return; }
      el.removeAttribute('hidden');
      if (end) setTimeout(check, Math.min(end - now + 500, 6 * 3600000));
    }
    check();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
